import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {BusinessDataService} from "@evomatik/evk-forms";
import {EvkSecurityControlDataService} from "@evomatik/evk-seguridad";
import {ConficuracionDocumentosModel, FiltroPaginadorDocumentosModel, LlaveNegocioModel} from "@evomatik/evk-content";
import {EvkOption} from "@evomatik/evk-common";

@Component({
    selector: 'lib-contenedor-formatos',
    templateUrl: './contenedor-formatos.component.html',
    encapsulation: ViewEncapsulation.None
})
export class ContenedorFormatosComponent implements OnInit {

    idExpediente: string;
    uuid: string;
    usuario: string;
    relativePath: string;
    destino: string;
    configuracionDocumentos: ConficuracionDocumentosModel;
    formatos: EvkOption[];
    difundir: string;

    constructor(
        public dialogRef: MatDialogRef<ContenedorFormatosComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private businessDataService: BusinessDataService,
        private evkSecurity: EvkSecurityControlDataService
    ) {
        if (data) {
            this.uuid = data.uuid;
            this.formatos = data.formatos;
            this.difundir = data.difundir;
            this.relativePath = data.relativePath;
            this.idExpediente = this.businessDataService.getValue('idExpediente');
        }
    }

    ngOnInit(): void {
        if (this.uuid) {
            this.relativePath = `Expedientes/${this.idExpediente}/Formatos/${this.uuid}`;
        } else {
            this.destino = 'especial';
        }
        this.usuario = this.evkSecurity.getUsuarioInfo().username;
        this.configuracionDocumentos = new ConficuracionDocumentosModel();
        // this.configuracionDocumentos.puesto = 'Test';
        this.configuracionDocumentos.usuario = this.evkSecurity.getUsuarioInfo().nombreCompleto;
        this.configuracionDocumentos.nombre = this.evkSecurity.getUsuarioInfo().username;
        this.configuracionDocumentos.relativePath = this.relativePath;
        this.configuracionDocumentos.canAdd = true;
        this.configuracionDocumentos.canEdit = true;
        this.configuracionDocumentos.canView = true;
        this.configuracionDocumentos.idNegocio = this.uuid ? this.uuid : this.idExpediente;
        this.configuracionDocumentos.llavesNegocio = [];
        this.configuracionDocumentos.metadatosNegocio = [];
        this.configuracionDocumentos.llavesNegocio.push(this.creaLlaveNegocio('idExpediente', this.businessDataService.getValue('idExpediente')));
        // this.configuracionDocumentos.llavesNegocio.push(this.creaLlaveNegocio('seccion', 'documentacionAportada'));
        this.configuracionDocumentos.filtro = new FiltroPaginadorDocumentosModel();
        this.configuracionDocumentos.filtro.relativePath = this.relativePath;
        this.configuracionDocumentos.showDescargaZip = false;
        this.configuracionDocumentos.destino = this.destino;
        this.configuracionDocumentos.difundir = this.difundir;
        // this.configuracionDocumentos.filtro.llavesNegocio = JSON.stringify([this.creaLlaveNegocio('idExpediente', this.businessDataService.getValue('idExpediente'))]);
    }

    creaLlaveNegocio(key: string, valor: any): LlaveNegocioModel {
        const llave = new LlaveNegocioModel();
        llave.llave = key;
        llave.valor = valor;
        return llave;
    }
}
